// 2024
/*
function checkUrlExists(url) {
  return fetch(url, { method: 'HEAD' })
    .then(response => {
      return response.ok;
    })
    .catch(() => {
      return false;
    });
}*/
let urlExists; // Declare a variable to store the result

function checkUrlExists(url) {
  return fetch(url, { method: 'HEAD' })
    .then(response => response.ok)
    .catch(() => false);
}

class ProductProcessor extends HTMLElement {
  constructor() {
    // @todo
    super();

    this.productData = [];
    this.variants = [];
    this.groupedVariants = {};
    this.currentVariant = {};
    this.currentVariantId = 0;

    this.getDataFromScript();
    this.getDataCurrentProductFromScript();
    this.groupVariantsByPrice();

    this.hideAnotherHTML();
    this.render();
    this.assignEvents();
    this.changeLabels(this.currentVariant);
    
    this.addClassFromIdReference(
      this.currentVariant.id,
      this.currentVariant.option1
    );


    this.printHTMLSize()
  }

  hideAnotherHTML(){
    const variantContainer = document.querySelector(".product-variant-block");
    variantContainer.classList.add("hidden");
  }

  printHTMLSize(){
    const { variantsJson } = this.groupedVariants.find(item => {
      return item.variantFormated.find(groupVariant => {
        return groupVariant.variants.find(variant => {
          return variant.id == this.currentVariantId
        })
      });
    });

    const swatches = variantsJson.filter(variant => variant.option1 == this.currentVariant.option1);
    this.printHTMLOptionSize(swatches);
    this.assignEventsSize();
  }

  variantAgroupByColor(variants) {
    const groupedData = variants.reduce((result, variant) => {
      const option1 = variant.option1;

      if (!result[option1]) {
        result[option1] = [];
      }

      result[option1].push(variant);

      return result;
    }, {});

    return Object.entries(groupedData).map(([color, variants]) => ({
      color,
      variants,
    }));
  }

  getDataFromScript() {
    const script = document.querySelector(
      "script[data-product-related]"
    ).textContent;
    this.productData = JSON.parse(script);

    this.variants = this.productData
      .map((product) => {
        return product.variants.map((variant) => ({
          ...variant,
          imageReference: product.featured_image,
          referenceId: product.id,
          referenceURL: product.url,
        }));
      })
      .flat();
  }

  getDataCurrentProductFromScript() {
    const script = document.querySelector(
      "script[data-current-product]"
    ).textContent;
    const product = JSON.parse(script);

    const variantCurrent = product.variants.map((variant) => ({
      ...variant,
      isCurrent: true,
      imageReference: product.featured_image,
      referenceId: product.id,
      referenceURL: product.url,
    }));

    this.currentVariant = product.variant_selected;
    this.currentVariantId = product.variant_id;

    this.variants = [...variantCurrent, ...this.variants];
    this.productData = [product, ...this.productData];
  }

  groupVariantsByPrice() {
    const priceMap = {};

    for (const variant of this.variants) {
      const price = parseFloat(variant.price);
      if (!priceMap[price]) {
        priceMap[price] = [];
      }
      priceMap[price].push(variant);
    }

    this.groupedVariants = Object.entries(priceMap).map(
      ([price, variants]) => ({
        price: parseFloat(price),
        variantsJson: variants,
        variantFormated: this.variantAgroupByColor(variants),
      })
    );

    this.groupedVariants.sort((a, b) => b.price - a.price);

  }

  assignEvents() {
    const links = document.querySelectorAll(".related-product-swatch-color");
    const changeVariant = this.setCurrentVariant.bind(this);

    links.forEach((link) => {
      link.addEventListener("click", function () {
        const variant = JSON.parse(this.getAttribute("data-variant"));
        changeVariant(variant);
      });
    });
  }

  findSwatchByColor(color) {
    return this.productData.find((product) =>
      product.options[0].values.includes(color)
    );
  }

  changeUrlFromCurrentVariant(id) {
    const currentURL = window.location.href;
    const urlObj = new URL(currentURL);
    const searchParams = urlObj.searchParams;

    searchParams.set("variant", id);

    const modifiedURL = urlObj.toString();
    history.pushState(
      {
        path: modifiedURL,
      },
      "",
      modifiedURL
    );
  }

  changeValueInput(id) {
    document.querySelector('input[name="product-id"]').value = id;

    const selectElement = document.querySelector("select[data-product-select]");
    selectElement.innerHTML = "";
    const optionElement = document.createElement("option");
    optionElement.value = id;
    optionElement.textContent = "";
    optionElement.selected = "selected";
    selectElement.appendChild(optionElement);
  }

  addClassFromIdReference(id, color = null) {
    const elements = document.querySelectorAll([
      `a[data-reference="${id}"]`,
      `a[reference="${color}"]`,
    ]);

    elements.forEach(function (element) {
      element.classList.add("active");
    });
  }

  clearClassActive() {
    const swatchElements = document.querySelectorAll(
      ".related-product-swatch-color"
    );

    swatchElements.forEach(function (element) {
      element.classList.remove("active");
    });
  }

  assignEventsSize() {
    const linksSize = document.querySelectorAll(
      ".related-product-swatch-color.size"
    );
    const changeVariant = this.setCurrentVariantSize.bind(this);

    linksSize.forEach((link) => {
      link.addEventListener("click", function () {
        const variant = JSON.parse(this.getAttribute("data-variant"));
        changeVariant(variant);
      });
    });
  }

  printHTMLOptionSize(variantsWithCurrent) {
    const variantContainer = document.querySelector(".container-variants-size");
    variantContainer.classList.add("hidden");

    const variantsSizeElement = document.querySelector(".variants-size");
    variantsSizeElement.innerHTML = "";

    const uniqueVariantIds = new Set();

    const variantsHtml = variantsWithCurrent
      .filter((variant) => {
        // Check if the variant ID is already in the set
        if (uniqueVariantIds.has(variant.id)) {
          // Duplicate found, return false to filter it out
          return false;
        } else {
          // Add the variant ID to the set
          uniqueVariantIds.add(variant.id);
          return true;
        }
      })
      .map((variant) => {
        const variantJson = JSON.stringify(variant);
        const isActive = variant.id == this.currentVariantId ? "active" : "";
        const isDisable = variant.available ? "" : "disabled";

        return `
                <div class="variants-grouped__group__size ${variant.id}">
                    <div class="variant-input">
                        <a 
                          data-reference="${variant.id}"
                          class="related-product-swatch-color size ${isActive} ${isDisable}" 
                          aria-label="${variant.option2}" 
                          data-variant='${variantJson}'
                        >
                            <label class="variant__button-label">
                                ${variant.option2}
                            </label>
                        </a>
                    </div>
                </div>
            `;
      })
      .join("");

    variantsSizeElement.innerHTML = variantsHtml;
    variantContainer.classList.remove("hidden");
  }

  changeLabels(variant) {
    const { title } = variant;

    const selectorColorText = document.querySelector("#label-color");
    selectorColorText && variant && (selectorColorText.innerHTML = title);
  }

  setGroupedVariant(variantsWithCurrent) {
    if (!variantsWithCurrent) return null;

    this.printHTMLOptionSize(variantsWithCurrent);
    this.assignEventsSize();
  }

  setSingleVariant(variant, setRedirect = false) {
    this.changeUrlFromCurrentVariant(variant.id);
    this.changeValueInput(variant.id);

    this.currentVariant = variant;
    this.currentVariantId = variant.id;

    this.changeLabels(variant);
    this.clearClassActive();
    this.addClassFromIdReference(variant.id, variant.option1);

    const url = variant.referenceURL;
    url &&
      setRedirect &&
      (window.location.href = url + "?variant=" + variant.id);
  }

  setCurrentVariant(variant) {
    const variantsWithCurrent = variant.variants ?? [];

    if (!!this.findVariantById(variantsWithCurrent)) {
      this.setGroupedVariant(variantsWithCurrent);
    }else{
      this.setSingleVariant(variant.variants[0], true);
    }

  }

  setCurrentVariantSize(variant) {
    variant && this.setSingleVariant(variant, false);
  }


  
  
  getVariantHTML(variant) {
    const { swatches, title, available } =
      this.findSwatchByColor(variant.variants[0].option1);

    const isActive = variant.variants[0].id == this.currentVariantId;

    const { imageCurrent, swatchFallback } = swatches[0];

    /**/ 
   

    // Call the checkUrlExists function and handle the result
    (async () => {
      try {
        // Call the checkUrlExists function and await the result
        urlExists = await checkUrlExists(imageCurrent);
    
        // Now you can use the urlExists variable as needed
        console.log(`The URL ${urlToCheck} exists: ${urlExists}`);
        
        // Example: Call another function that uses urlExists
        anotherFunction();
      } catch (error) {
        console.error(`Error checking URL: ${error}`);
      }
    })();

    /**/

    const divElement = document.createElement("div");
    divElement.className = "variants-grouped__variant";

    const innerDiv = document.createElement("div");
    innerDiv.className = "variants-grouped__variant__image";

    const linkElement = document.createElement("a");
    linkElement.setAttribute("aria-label", title);
    linkElement.setAttribute("reference", variant.color);
    linkElement.setAttribute("data-reference", variant.variants[0].id);

    const currentClasses = linkElement.className.split(" ");

    const newClasses = [
      "related-product-swatch-color",
      ...(available ? [] : ["disabled"]),
      ...(isActive ? ["active"] : []),
    ];

    const combinedClasses = [...new Set([...currentClasses, ...newClasses])];
    linkElement.className = combinedClasses.join(" ");

    const variantJson = JSON.stringify(variant);
    linkElement.setAttribute("data-variant", variantJson); 

    const labelElement = document.createElement("label");
    labelElement.className = "variant__button-label color-swatch color-swatch-js";
    labelElement.style.background = swatchFallback;

    setTimeout(() => {
      //labelElement.classList.add = 'urlExists';
      console.log('urlExists' + urlExists + labelElement);
      labelElement.dataset.someData = "mydata2";      
    }, "100");
     
    
    labelElement.style.backgroundImage = `url(${imageCurrent})`;
    

    
    
    linkElement.appendChild(labelElement);
    innerDiv.appendChild(linkElement);
    divElement.appendChild(innerDiv);

    

    return divElement.outerHTML;
  }


  


  formatPrice(price) {
    //return Shopify.formatMoney(price);
     // Usa Shopify.formatMoney para obtener el precio formateado
     let formattedPrice = Shopify.formatMoney(price);
    
     // Verifica si el precio termina en ".00"
     if (formattedPrice.endsWith('.00')) {
         // Elimina los decimales si el precio es un número entero
         formattedPrice = formattedPrice.replace('.00', '');
     }
     
     return formattedPrice;
  }

  findVariantById(variants) {
    return variants.find((variant) => variant.id == this.currentVariantId) || false;
  }

  render() {
    const template = document.createElement("template");
    template.innerHTML = `
            <div class="container-variants-color">
              <label>Color - <span id="label-color"></span></label>
            </div>
            <div class="variants-grouped" >
                ${this.groupedVariants
                  .map((group) => {
                    return `
                          <div class="variants-grouped__group">
                              <div class="variants-grouped__group__price this">
                                  ${this.formatPrice(group.price)}
                              </div>
                              <div class="variants-grouped__formated">
                                  ${group.variantFormated
                                    .map((variant) =>
                                      this.getVariantHTML(variant)
                                    )
                                    .join("")}
                              </div>
                          </div>
                        `;
                  })
                  .join("")}
            </div>
            <div class="container-variants-size">
              <div class="label-flex">
              <label>Size</label>
              <span id="open-popup-size-chart" class="popup-link">Size chart</span>
              </div>                
              <div class="variants-size"></div>
            </div>
        `;

    this.appendChild(template.content.cloneNode(true));
  }
}

customElements.define("product-processor", ProductProcessor);
